module.exports = __webpack_public_path__ + "media/images/snack_logo-171f1311ee693fc58c21db76a0b9a5f0.svg";